<template>
  <div class="page-header d-flex align-center mb-6">
    <v-icon v-if="icon" :color="color" size="28" class="mr-3">{{ icon }}</v-icon>
    <div>
      <div class="text-h5 font-weight-bold">{{ title }}</div>
      <div v-if="subtitle" class="text-body-2 text-medium-emphasis mt-1">{{ subtitle }}</div>
    </div>
    <v-spacer />
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: null },
    subtitle: { type: String, default: null },
    color: { type: String, default: "primary" },
  },
};
</script>
